// function openCity(evt, cityName) {
//   var i, tabcontent, tablinks;
//   tabcontent = document.getElementsByClassName("tabcontent");
//   for (i = 0; i < tabcontent.length; i++) {
//     tabcontent[i].style.display = "none";
//   }
//   tablinks = document.getElementsByClassName("tablinks");
//   for (i = 0; i < tablinks.length; i++) {
//     tablinks[i].className = tablinks[i].className.replace(" active", "");
//   }
//   document.getElementById(cityName).style.display = "block";
//   evt.currentTarget.className += " active";
// }




// Function to open a specific tab
function openCity(evt, cityName) {
  // Hide all tab contents
  const tabcontents = document.querySelectorAll('.tabcontent');
  tabcontents.forEach(content => content.style.display = 'none');

  // Remove the active class from all tab links
  const tablinks = document.querySelectorAll('.tablinks');
  tablinks.forEach(link => link.classList.remove('active'));

  // Show the current tab content and add the active class to the clicked tab
  document.getElementById(cityName).style.display = 'block';
  evt.currentTarget.classList.add('active');
}

// Automatically open the first tab on page load
document.addEventListener('DOMContentLoaded', () => {
  const firstTab = document.querySelector('.tablinks');
  const firstContentId = firstTab.getAttribute('onclick').match(/'([^']+)'/)[1];

  // Simulate a click on the first tab
  firstTab.classList.add('active');
  document.getElementById(firstContentId).style.display = 'block';
});










// DROPDOWN MENU
const dropdown = document.querySelector(".dropdown");
dropdown.addEventListener("click", function () {
  dropdown.classList.toggle("open");
});


